import { Theme, PaletteMode, responsiveFontSizes } from '@mui/material';
import { createTheme, ComponentsOverrides } from '@mui/material/styles';

const getTheme = (): Theme =>
  responsiveFontSizes(
    createTheme({
      palette: {
        mode: 'dark' as PaletteMode,
        background: {
          // default: 'rgb(0, 0, 0)',
          default: '#F7FCE8',    //beige color
          
          // paper: 'rgb(15, 15, 15)',
          // paper: 'rgb(15, 47, 163)',
          // paper: 'rgb(13, 41, 140)',
          paper: '#F8FFF8',       //powder white     
        
        },
        text: {
          // primary: 'rgb(255, 255, 255)',
          // primary: 'rgb(11, 34, 116)',
          // primary: 'rgb(143, 255, 85)',

          // primary: '#363537',
          primary: '#212121',                     //Text color set to black                     
          // secondary: 'rgb(207, 207, 207)',
          // secondary: 'rgb(217, 255, 191)',
          // secondary: 'rgb(224, 255, 204)',
          secondary: 'black',
        },
        primary: {                                //Contained Button color (green) & Button text (black)
          //main: 'rgb(129, 187, 89)',
          //main: 'rgb(143, 255, 85)',
          // main: 'rgb(252, 24, 54)',
           main: '#CAFF59',                     //Button color set as light green
          
         
          //main: 'rgb(255, 255, 255)',
         
           contrastText: '#212121',               //Text color for button set to black
        },
        divider: 'rgba(145, 158, 171, 0.24)',
        
      },
      typography: {
        fontFamily: '"Poppins", sans-serif',
      },
      components: {
        MuiSvgIcon: { // Add this section for icon color override
          styleOverrides: {
            root: {
              color: 'black', // Change the color of all icons to black
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              '& .MuiInputLabel-root': {
                color: 'black', // Change the color of the floating label to #363537
              },
              '& .MuiInputBase-input': {
                color: 'black', // Change the color of the text input to #363537
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: 'black', // Change the border color of the text field to #363537
                },
                '&:hover fieldset': {
                  borderColor: 'black', // Change the border color on hover to #363537
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'black', // Change the border color when focused to #363537
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: 'black', // Change the color of the floating label when focused to #363537
              },
            },
          },
        },
        MuiDrawer: {
          styleOverrides: {
            paper: {
              backgroundColor: '#363537', // Background color for the drawer
              color: '#FCFFF8', // Text color for the drawer
            },
          },
        },
        MuiListItem: {
          styleOverrides: {
            root: {
              '&:hover': {
                backgroundColor: '#CAFF59', // Change background color on hover
                color: 'black', // Change text color on hover
              },
            },
          },
        },
         MuiSelect: { // Add overrides for MuiSelect
           styleOverrides: {
             root: {
               color: 'black', // Text color
               backgroundColor: '#F7FCE8', // Background color
              "& .MuiSelect-root": { 
                minHeight: 40,
                color: 'black', // Set the color of the select box text
                '&:focus': {
                  backgroundColor: 'transparent', // Set the background color when focused
                },
              },
              "& .MuiInputBase-root": { 
                height: 40, 
                '&.Mui-focused': {
                  backgroundColor: 'transparent', // Set the background color when focused
                },
              },
              "& .MuiMenuItem-root.Mui-selected": {
                color: 'black', // Set the color of the selected option text
                backgroundColor: 'transparent', // Set the background color of the selected option
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'black', // Set the border color of the outlined input
              },
              '& .MuiSelect-icon': {
                color: 'black', // Set the color of the dropdown icon
              },
            },
           },
         },
      
    
      
        MuiButton: {
          styleOverrides: {
            root: {
              fontWeight: 600,
              borderRadius: 0,
              paddingTop: 10,
              paddingBottom: 10,
            },
          } as ComponentsOverrides['MuiButton'],
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            
          } as ComponentsOverrides['MuiInputBase'],
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            input: {
              borderRadius: 0,
            },
          } as ComponentsOverrides['MuiOutlinedInput'],
        },
        MuiCard: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
          } as ComponentsOverrides['MuiCard'],
        },
        MuiLink: { // Add this section for link color override
          styleOverrides: {
            root: {
              color: '#363537', // Change the link color to black
              '&:hover': {
                color: '#363537', // Maintain the same color on hover
              },
            },
          },
        },
      },
    })
  );

export default getTheme;
